// extracted by mini-css-extract-plugin
export default {"NewProjectAdminDialog":"NewProjectAdminDialog_NewProjectAdminDialog__KFAhs"};